import _ from 'lodash';
import AnswerType from '../model/AnswerType';

export function sortByOrder<T extends { order: number }>(
  data: T[],
  isRandom?: boolean
): T[] {
  return isRandom ? _.shuffle(data) : _.sortBy(data, ['order']);
}
export function sortByTyp<T extends { typ: AnswerType }>(data: T[]): T[] {
  return _.sortBy(data, [o => o.typ !== AnswerType.ParticipantDefined]);
}
export function sortByOrderAndType<
  T extends { order: number; typ: AnswerType }
>(options: T[], isRandom?: boolean) {
  const part = _.partition(options, o => o.typ === AnswerType.Standard);
  if (isRandom) {
    return _.concat(sortByOrder(part[0], true), sortByTyp(part[1]));
  } else {
    return _.concat(sortByOrder(part[0], false), sortByTyp(part[1]));
  }
}
